import {Component, Input, OnInit} from '@angular/core';
import {EntityType, IncidentTransaction} from '@npck/af-frontend-api';

@Component({
    selector: 'af-transaction',
    templateUrl: 'incident-transaction.component.html',
    styleUrls: ['incident-transaction.component.scss'],
    standalone: false,
})
export class IncidentTransactionComponent implements OnInit {
    @Input() transaction: IncidentTransaction;
    @Input() index: string;
    @Input() isExpanded: boolean;
    @Input() incidentTypeCode: string;
    EntityType = EntityType;
    tabs: TransactionTab[] = ['tabTransactionCommon', 'tabTransactionDroppers', 'tabTransactionHistory'];
    selectedTabIndex: number;

    ngOnInit(): void {
        if (this.transaction?.loanInfo) {
            this.tabs = ['tabTransactionCommon', 'tabTransactionCreditInfo', 'tabTransactionDroppers', 'tabTransactionHistory'];
        } else if (this.transaction?.merchantInfo) {
            this.tabs = ['tabTransactionCommon', 'tabTransactionPaymentInfo', 'tabTransactionDroppers', 'tabTransactionHistory'];
        }
    }
}

export declare type TransactionTab =
    'tabTransactionCommon' | 'tabTransactionPaymentInfo' | 'tabTransactionCreditInfo' | 'tabTransactionDroppers' | 'tabTransactionHistory';
